/**
 * Utility functions for HTML content validation
 */

const getTrimmedTextContent = (html: string): string => {
  if (!html) return ''

  const tempDiv = document.createElement('div')
  tempDiv.innerHTML = html
  return (tempDiv.textContent ?? tempDiv.innerText ?? '').trim()
}

/**
 * Normalizes editor html into app-ready content.
 * Returns an empty string for visually empty markup (for example: <p><br></p>).
 */
export const normalizeEditorContent = (html: string): string => {
  return getTrimmedTextContent(html) ? html : ''
}
